import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteTopicMaster = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        instituteSyllabusStructureMasterId: '',
        instituteLessonMasterId: '',
        instituteTopicName: [''],
        instituteSubjectMasterId: ''
    }

    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [topicData, setTopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusStructureNameSort, setSyllabusStructureNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName", "instituteSubjectMasterDetails.subjectName", "instituteLessonMasterDetails.instituteLessonName", "instituteTopicName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getTopicList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setTopicList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(topicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(topicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > topicList.length) {
            endIndex = topicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(topicList.slice(startIndex, endIndex));
    }, [topicList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `/get-institute-topic-master?instituteMasterId=${instituteMasterId}&`;

        if (topicData.instituteSyllabusStructureMasterId !== '') {
            apiUrl += `instituteSyllabusStructureMasterId=${topicData.instituteSyllabusStructureMasterId}&`;
        }

        if (topicData.instituteLessonMasterId !== '') {
            apiUrl += `instituteLessonMasterId=${topicData.instituteLessonMasterId}&`;
        }

        if (topicData.instituteSubjectMasterId !== '') {
            apiUrl += `instituteSubjectMasterId=${topicData.instituteSubjectMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        if (topicData.instituteSyllabusStructureMasterId.length !== 0 && topicData.instituteSubjectMasterId !== '') {
            getTopicList();
        }
    }, [topicData.instituteSyllabusStructureMasterId, topicData.instituteSubjectMasterId, topicData.instituteLessonMasterId]);

    const getTopicList = async () => {
        try {
            const response = await authorizedAxiosInstitute.get(getApiUrl());
            setTopicList(response.data.result);
        } catch (error) {
            setTopicList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const handleInputChange = (e, index) => {
        setTopicData((prevData) => {
            if (e.target.name === 'instituteTopicName') {
                const updatedTopicName = [...prevData.instituteTopicName];
                updatedTopicName[index] = e.target.value;
                return {
                    ...prevData,
                    instituteTopicName: updatedTopicName,
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value
                }
            }
        })
    }

    const handleAddTopic = () => {
        setTopicData((prevData) => ({
            ...prevData,
            instituteTopicName: [...prevData.instituteTopicName, ''],
        }));
    };
    const handleRemoveTopic = (index) => {
        setTopicData((prevData) => {
            const updatedTopicName = [...prevData.instituteTopicName];
            // Remove the element at the specified index
            updatedTopicName.splice(index, 1);
            return {
                ...prevData,
                instituteTopicName: updatedTopicName,
            }
        });
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `get-institute-syllabus-structure?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: '',
                instituteLessonMasterId: ''
            }
        })
        const apiUrl = `get-institute-syllabus-structure-Wise-institute-subjects?id=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteLessonMasterId: ''
            }
        })

        const apiUrl = `get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${topicData.instituteSyllabusStructureMasterId}&instituteSubjectMasterId=${e.target.value}`
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        const noErrors = Object.values(error).every((error) => error === '');

        const allValuesValid = Object.entries(topicData).every(([key, value]) => {
            if (key === 'instituteTopicName' && Array.isArray(value)) {
                return value.every(topic => typeof topic === 'string' && topic.trim() !== '');
            } else {
                return typeof value === 'string' && value.trim() !== '';
            }
        });

        return noErrors && allValuesValid;
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(topicData)) {
                if (key === "instituteTopicName") {
                    for (const topic of topicData.instituteTopicName) {
                        if (topic === '' || topic.length === 0) {
                            setError((prevData) => ({
                                ...prevData,
                                instituteTopicName: 'This field is required.',
                            }));
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    [key]: '',
                                }
                            });
                        }
                    }
                } else if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [topicData])

    const addTopic = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-topic-master`;
                const response = await authorizedAxiosInstitute.post(apiUrl, topicData);
                await getTopicList();
                setTopicData((prevData) => {
                    return {
                        ...prevData,
                        instituteTopicName: [''],
                    }
                })
                setSaveId(response.data.result[0].id);
                setSyllabusStructureNameSort(null);
                setSubjectSort(null);
                setLessonNameSort(null);
                setTopicNameSort(null);
                setSearchValue(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(topicData)) {
                if (key === "instituteTopicName") {
                    for (const topic of topicData.instituteTopicName) {
                        if (topic === '' || topic.length === 0) {
                            setError((prevData) => ({
                                ...prevData,
                                instituteTopicName: 'This field is required.',
                            }));
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    [key]: '',
                                }
                            });
                        }
                    }
                } else if (value == '') {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteTopic = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-topic-master?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, topicList.length);
                await getTopicList();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateTopic = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-topic-master?id=${editId}`;
            const response = await authorizedAxiosInstitute.put(apiUrl, topicData);
            await getTopicList();
            setEditId(null);
            setTopicData((prevData) => {
                return {
                    ...prevData,
                    instituteTopicName: [''],
                }
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    const handleInputReset = () => {
        setTopicList([]);
        setEditId('');
        setTopicData(initialFormState);
        setError(initialErrorState)
    }

    useEffect(() => {
        if (syllabusStructureNameSort == true || syllabusStructureNameSort == false) {
            setSubjectSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [syllabusStructureNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
        }
    }, [topicNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Institute Topic Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-hashtag"></i> Institute Topic Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSyllabusStructureMasterId' onChange={handleSyllabusChange} value={topicData.instituteSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.instituteSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.instituteSyllabusStructureMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={topicData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteLessonMasterId' onChange={handleInputChange} value={topicData.instituteLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.instituteLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteLessonMasterId && <p style={{ color: 'red' }}>{error.instituteLessonMasterId}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                {topicData.instituteTopicName.map((topic, index) => (
                                                    <>
                                                        <div className="col-md-12">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Section Topic Name :</label>
                                                            <input type="text" className="form-control" id={`instituteTopicName${index}`} name='instituteTopicName' onChange={(e) => handleInputChange(e, index)} value={topic} />
                                                            {error.instituteTopicName && topic.length === 0 && <p style={{ color: 'red' }}>{error.instituteTopicName}</p>}
                                                        </div>
                                                        {topicData.instituteTopicName.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveTopic(index)} ><i className="material-icons" style={{ fontSize: '20px' }}>delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                                {!editId && (
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ width: '220px' }} onClick={handleAddTopic}>+ Add Another Topic Name</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {
                                                        !editId && <button className="btn btn-primary" type="button" onClick={addTopic}>Save</button>
                                                    }

                                                    <button className="btn btn-outline-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>

                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateTopic} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Structure Name
                                                                            <SortIcon sortState={syllabusStructureNameSort} setSortState={setSyllabusStructureNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"instituteLessonMasterDetails.instituteLessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"instituteTopicName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((topic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{topic.instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName}</td>
                                                                                        <td>{topic.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                        <td>{topic.instituteLessonMasterDetails?.instituteLessonName}</td>
                                                                                        <td>{topic.instituteTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn-outline-warning edit_icon" title='Coming Soon...' disabled type="button" onClick={() => {
                                                                                                setTopicData({
                                                                                                    instituteMasterId: instituteMasterId,
                                                                                                    instituteSyllabusStructureMasterId: topic.instituteSyllabusStructureMasterDetails.id,
                                                                                                    instituteLessonMasterId: topic.instituteLessonMasterDetails?.id,
                                                                                                    instituteTopicName: [topic.instituteTopicName],
                                                                                                    instituteSubjectMasterId: topic.instituteSubjectMasterDetails.id
                                                                                                });
                                                                                                setEditId(topic.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn-outline-danger delete_icon" title='Coming Soon...' disabled type="button" /*disabled={editId === topic.id}*/ onClick={() => deleteTopic(topic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Topic Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={topicList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteTopicMaster;